import { Chip } from '@/global/components/Chip'
import { usePlanosContext } from '@/pages/Planos'
import { match } from 'ts-pattern'

export default function ChipStatusAssinatura() {
    const { assinatura } = usePlanosContext()

    if (!assinatura?.status) return null

    const label = match(assinatura.status)
        .with('active', () => 'Ativa')
        .with('canceled', () => 'Cancelada')
        .with('closed', () => 'Encerrada')
        .with('stopped', () => 'Interrompida')
        .with('waitingPayment', () => 'Aguardando pagamento')
        .with('inactive', () => 'Inativa')
        .otherwise(() => assinatura?.status)

    const color = match(assinatura?.status)
        .with('active', () => 'success' as const)
        .with('canceled', () => 'error' as const)
        .with('closed', () => 'info' as const)
        .with('stopped', () => 'warning' as const)
        .with('waitingPayment', () => 'warning' as const)
        .with('inactive', () => 'info' as const)
        .otherwise(() => undefined)

    return [
        <Chip
            label={label}
            color={color}
            className="hidden sm:inline-flex select-none"
            key="desktop"
        />,
        <Chip
            label={' '}
            color={color}
            className="sm:hidden rounded-full size-6 cursor-pointer"
            title={label}
            key="mobile"
        />,
    ]
}
